import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { ERROR_CODE } from '../common';

interface ApiResponse <T = any> {
  data: T;
  status: number;
}

// 创建 axios 实例
const instance = axios.create({
  baseURL: '/',
  timeout: 10000,
  withCredentials: true,
  // withCredentials: CUSTOM_COUNTRY.toLowerCase() === 'cn',
  headers: {
    'Content-Type': 'application/json',
  },
});

// request 拦截器
instance.interceptors.request.use(
  (config) => config,
  (error: AxiosError<Error>) => Promise.reject(error)
);

// response 拦截器
instance.interceptors.response.use(
  (response: AxiosResponse) => {
    const { data } = response;
    if (!data || ((data.code || data.data?.error_code) !== 0 && data.BaseResp?.StatusCode !== 0)) {
      // 抛出请求返回的错误信息
      throw {
        code: data.code || data?.data?.error_code || -1,
        data: data.data || {},
        msg: data.et || data.em || data?.data?.description || '请求返回数据出现异常',
      };
    }

    return response.data;
  },
  (err: AxiosError<ApiResponse>) => {
    if (err.response) {
      const { data, status } = err.response;

      // 抛出 http 请求的错误信息
      throw {
        code: status,
        data: data.data || {},
        msg: ERROR_CODE[status] || '网络请求失败',
      };
    }
    return Promise.reject(err);
  }
);

export default instance;
